export default __webpack_public_path__ + "static/media/DRIBBLING TRAINING SETUP.aa0583b0.png";